import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Tooltip from '@mui/material/Tooltip';
import {
  getvendorsPOList,
  downloadProjectPO,
  getProject,
  savePurchaseOrder,
  getProjectList,
  getPoVendors,
  getPOList,
  getPOInvoices,
} from "../../../actions/project-management.action";
import { warningSnackBar, successSnackBar } from "../../../actions/common.action";
import PayInvoice from "../../vendor-payment/pay-invoice";
import ReceiveCredit from "./receive-credit";
import { PROJECT_MANAGEMENT, SUPPLIERS, VENDOR_PAYMENT } from "../../../constants/route-paths";
import { format } from "date-fns";
import DateFilter from "../../../components/date-filter-dialog"
import { numberFormat } from "../../../util/currency-formatter";
import DownloadDialog from "../../../components/download-dialog";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Autorenew } from "@mui/icons-material";
import { withRouter } from "../../../util/with-router";
import { getGlobalSettingTemplateTypes } from "../../../actions/global-setting-template.action";
import { getGlobalSetting } from "../../../actions/global-setting.action";
import '../../projects/scss/task.scss'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Popover from 'react-bootstrap/Popover';
import idx from "idx";
import { resolveProjectType } from "../../projects/utils/resolve-project-type";
import CustomTable from '../../../components/table/table';
import { getVendorList } from "../../../actions/vendor-management.action";

function SupplierInvoiceList({ projectModule, writePermission, ...props }) {

  const [state, setState] = useState({// declare initial variables
    showPayInvoice: false,
    showReceiveCredit: false,
    columns: [],
    list: [],
    submitDialog: false,
    discardDialog: false,
    supplierCount: null,
    subContractorCount: null,
    vendorType: "ALL",
    invoiceData: {},
    workType: "project",
    projectId: null,
    suppliers: [],
    suppliersTable: [],
    templateOptions: [],
    subContractors: [],
    allInvoices: [],
    breadCumbText: null,
    showFilter: false,
    downloadData: {
      open: false,
      id: "",
      template: "",
    },
    projectData: null,
    startDate: '',
    endDate: '',
    invoiceType: 'ALL'
  })

  useEffect(() => {
    init()
  }, [])

  const init = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("project");
    const poId = urlParams.get("poId");

    let breadCumbText = null;
    if (projectId) {
      breadCumbText = "Project";
    }

    setState(prev => ({
      ...prev,
      projectId, poId, breadCumbText
    }));
    fetchList()

    if (!state.projectData && projectId) {
      props.getProject(projectId).then((projectData) => {
        setState(prev => ({
          ...prev,
          projectData: projectData
        }));
      })
    }
  }

  const handleMenu = (rowData) => {
    setState(prev => ({
      ...prev,
      poId: rowData.poId,
      invoiceId: rowData.invoiceId,
      invoiceData: {
        poId: rowData.poId,
        poNo: rowData.poNumber,
        isSubContractor: rowData.vendorType === "sub-contractor",
        isCreditInvoice: !!rowData.isCreditInvoice,
        invoiceId: rowData.invoiceId,
      },
    }));
  };

  const handlePayInvoiceModal = (status, allProjects = false) => {
    if (!status) {
      fetchList();
    }
    setState(prev => ({
      ...prev,
      showPayInvoice: status,
      invoiceData: { ...(allProjects ? {} : { ...prev.invoiceData }) },
    }));
  };

  const handleReceiveCreditModal = (status, allProjects = false) => {
    if (!status) {
      fetchList();
    }
    setState(prev => ({
      ...prev,
      showReceiveCredit: status,
      invoiceData: { ...(allProjects ? {} : { ...prev.invoiceData }) },
    }));
  };

  const fetchList = async ({ pageNo, pageSize, vendorType, startDate, endDate, } = {}) => {
    const params = {
      pageNo,
      pageSize,
      vendorType: 'Supplier',
      startDate,
      endDate,
    };
    let { projectId, poId } = state;
    if (projectId) {
      params.projectId = projectId;
    }
    if (poId) {
      params.poId = poId;
    }
    setState(prev => ({
      ...prev,
      vendorType: vendorType || "ALL",
    }));

    let { list, vendorTypesCount } = await props.getvendorsPOList(params);

    list = (Array.isArray(list) && list.filter(({ isCreditInvoice, invoiceId }) => !(isCreditInvoice && !invoiceId))) || [];

    const suppliers = (Array.isArray(list) && list.filter(({ vendorType }) => vendorType === "Supplier")) || [];
    const subContractors = (Array.isArray(list) && list.filter(({ vendorType }) => vendorType === "sub-contractor")) || [];
    const allInvoices = (Array.isArray(list) && list) || [];
    const supplierCount = vendorTypesCount.suppliersCount || 0;
    const subContractorCount = vendorTypesCount.subContractorsCount || 0;
    const columns = [
      {
        title: "Vendor Name",
        field: "vendorName",
        dataCy: "vendor-name",
        render: (rowData) => rowData.vendorName
      },
      {
        title: "Invoice Type",
        field: "invoiceType",
        dataCy: "invoice-type",
        render: (rowData) => rowData.isCreditInvoice ? "Credit" : "Regular"
      },
      // {
      //   title: "Vendor Type",
      //   field: "vendorType",
      //   // lookup: { "sub-contractor": "Sub-Contractor", Supplier: "Supplier" },
      //   render: (rowData) => rowData.vendorType == 'sub-contractor' ? "Sub-Contractor" : rowData.vendorType
      // },
      {
        title: "Invoice No",
        field: "invoiceNo",
        dataCy: "invoice-no",
        render: (rowData) => (
          <span>{rowData.invoiceNo || (rowData.isCreditInvoice ? 'Credit Invoice' : '')}</span>
        ),
      },
      {
        title: "PO Number",
        field: "poNumber",
        dataCy: "po-number",
        /* fId is the PO number with project prefix and Suffix if null then default to po Number*/
        render: (rowData) => rowData.fId || rowData.poNumber
      },
      { title: "Project/Job", field: "projectName", render: (rowData) => rowData.projectName },
      {
        title: "Invoice Date",
        field: "invoiceDate",
        type: 'date',
        dataCy: "invoice-date",
        render: (rowData) => {
          return (rowData.invoiceDate && format(new Date(rowData.invoiceDate), "dd/MM/yyyy")) || "";
        },
      },
      {
        title: "Due Date",
        field: "dueDate",
        type: 'date',
        dataCy: "due-date",
        render: (rowData) => {
          if (rowData.dueDate) {
            try { return format(new Date(rowData.dueDate), "dd/MM/yyyy"); } catch (e) { return rowData.dueDate }
          }
          if (rowData.isCreditInvoice && rowData.notes) {
            const dueDateMatch = rowData.notes.match(/Due Date: ([^,]+)/);
            if (dueDateMatch && dueDateMatch[1] && dueDateMatch[1] !== 'Not specified') {
              try {
                return format(new Date(dueDateMatch[1]), "dd/MM/yyyy");
              } catch (e) {
                return dueDateMatch[1];
              }
            }
          }
          return "";
        },
      },
      {
        title: "Amount Paid / Credit Amount",
        field: "amountPaid",
        dataCy: "amount-paid",
        render: (rowData) => {
          if (rowData.isCreditInvoice) {
            const apiValue = (rowData.receiveCreditAmount ?? rowData.receive_credit_amount ?? rowData.invoiceClaim);
            if (apiValue !== undefined && apiValue !== null && !isNaN(parseFloat(apiValue))) {
              return `${numberFormat(parseFloat(apiValue))}`;
            }
            if (rowData.notes) {
              const creditAmountMatch = rowData.notes.match(/Credit Amount: ([^,}]+)/);
              if (creditAmountMatch && creditAmountMatch[1]) {
                try {
                  const amount = parseFloat(creditAmountMatch[1]);
                  return `${numberFormat(amount)}`;
                } catch (e) {
                  return creditAmountMatch[1];
                }
              }
            }
            return '';
          }
          return `${numberFormat(rowData.amountPaid)}`;
        },
        class: 'text-right',
      },
      // {
      //   title: "Notes",
      //   field: "notes",
      //   render: (rowData) => rowData.isCreditInvoice ? rowData.notes : "",
      // },
      // {
      //   title: "Retained Amount",
      //   field: "retainedAmount",
      //   render: (rowData) => `${numberFormat(rowData.retainedAmount)}`,
      //   class: 'text-right',
      // },
      {
        title: "Received By",
        field: "userName",
        dataCy: "received-by",
        render: (rowData) => rowData.userName
      },
    ];
    list.forEach((item, index) => {
      item["id"] = index;
      return item;
    });
    setState(prev => ({ //renew state variables
      ...prev,
      supplierCount,
      subContractorCount,
      columns,
      list,
      suppliers, //non-changable data
      suppliersTable: suppliers, //changable data 
      subContractors,
      allInvoices,
    }));
  };

  const viewPO = async () => {
    let { workType, invoiceId, projectId, poId, invoiceData } = state;
    console.log('viewPO invoked with:', { workType, invoiceId, projectId, poId })
    if (!invoiceId && poId) {
      try {
        const invoices = await props.getPOInvoices(poId);
        let firstId = null
        if (Array.isArray(invoices)) {
          firstId = invoices[0] && invoices[0].id
        } else if (invoices && Array.isArray(invoices.invoice)) {
          firstId = invoices.invoice[0] && invoices.invoice[0].id
        }
        console.log('resolved first invoice id:', firstId)
        if (firstId) invoiceId = firstId;
      } catch (e) { console.log('getPOInvoices error:', e) }
    }
    if (!invoiceId) {
      props.warningSnackBar('Invoice not available yet. Please refresh and try again.');
      return;
    }
    const url = `/${SUPPLIERS}/${VENDOR_PAYMENT}/view/${invoiceId}${`?type=${workType}`}${projectId ? `&id=${projectId}` : ""}${poId ? `&poId=${poId}` : ""}`
    props.history(
      url
    );
  };

  const showFilterHandler = () => {
    setState(prev => ({
      ...prev,
      showFilter: !prev.showFilter,
    }));
  };

  const convertDateFormat = (dateString) => {
    let date = Date.parse(dateString);
    date = new Date(date)
    return date
  }

  const resetInvoiceData = () => {
    setState(prev => ({
      ...prev,
      startDate: '',
      endDate: '',
      invoiceType: 'ALL',
      suppliersTable: structuredClone(prev.suppliers)
    }))
    fetchList()
  }

  const dateChangeFilter = (startDate, endDate, invoiceType) => {
    let table = [...state.suppliers]

    if (startDate || endDate) {
      table = table.filter(({ invoiceDate }) => {
        const newDate = convertDateFormat(invoiceDate)
        if (!newDate) return false

        const startDateObj = startDate ? new Date(startDate) : null
        const endDateObj = endDate ? new Date(endDate) : null

        let matchesStart = true
        let matchesEnd = true

        if (startDateObj) {
          matchesStart = newDate >= startDateObj
        }

        if (endDateObj) {
          matchesEnd = newDate <= endDateObj
        }

        return matchesStart && matchesEnd
      })
    }

    if (invoiceType && invoiceType !== 'ALL') {
      table = table.filter((item) => {
        const itemInvoiceType = item.isCreditInvoice ? 'Credit' : 'Regular'
        return itemInvoiceType === invoiceType
      })
    }

    setState(prev => ({
      ...prev,
      suppliersTable: structuredClone(table),
      startDate,
      endDate,
      invoiceType: invoiceType || 'ALL'
    }))
    showFilterHandler()
  };

  const gettemplate = async (type) => {
    let newdata = [];
    let projectId = state.projectId;
    const templateData = await props.getGlobalSettingTemplateTypes(type, projectId);
    if (Array.isArray(templateData)) {
      templateData.forEach((item) => {
        newdata.push({
          value: item.id,
          key: item.name,
        });
      });
    }
    setState(prev => ({
      ...prev,
      templateOptions: newdata
    }));
  };

  const handleDownloadDialog = (id = "", templateType = "subcontractor_payment_schedule", overrideData = null) => {
    const currentId = id && (typeof id === 'string' || typeof id === 'number') ? id : state.invoiceId;
    setState(prev => {
      const isOpening = !prev.downloadData.open;
      const newState = {
        ...prev,
        downloadData: {
          ...prev.downloadData,
          open: isOpening,
          id: currentId,
          overrideData
        }
      };
      return newState;
    });

    if (!state.downloadData.open) {
      gettemplate("subcontractor_payment_schedule", currentId);
    }
  };

  const downloadFile = async (fileFormat = "pdf", templatevalue) => {
    try {
      const { downloadData = {} } = state;
      if (fileFormat === "pdf" || fileFormat === "ALL") {
        await props.downloadProjectPO(downloadData.id, fileFormat, templatevalue, undefined, downloadData.overrideData).catch(e => console.error(e));
      }
      if (fileFormat === "docx" || fileFormat === "ALL") {
        await props.downloadProjectPO(downloadData.id, fileFormat, templatevalue, undefined, downloadData.overrideData).catch(e => console.error(e));
      }
      handleDownloadDialog();
    } catch (e) {
      console.error(e)
    }
  };

  // const viewInvoice = (rowData) => {
  //   setState(prev => ({
  //     ...prev,
  //     invoiceId: rowData.invoiceId,
  //     invoiceData: {
  //       poNo: rowData.poNumber,
  //       poNumber: rowData.poId,
  //       isSubContractor: rowData.vendorType === "sub-contractor",
  //     },
  //   }));
  //   viewPO();
  // }

  const ViewProjectList = () => {
    let type = resolveProjectType(idx(state, (_) => _.projectData.projectType), props.projectState);
    props.history(`/${PROJECT_MANAGEMENT}?project-type=${type}`);
  }

  const ViewProject = () => {
    let { projectId } = state;
    props.history(`/${PROJECT_MANAGEMENT}/view/${projectId}`);
  }

  return (
    <>
      <DownloadDialog
        {...(state.downloadData || {})}
        handleDownloadDialog={handleDownloadDialog}
        downloadFile={downloadFile}
        templateOptions={state.templateOptions || []}
        downloadModuleName="Vendor Payment"
      />
      {state.showPayInvoice && (
        <PayInvoice
          {...(state.invoiceData || {})}
          workType={state.workType}
          handleDownloadDialog={handleDownloadDialog}
          handleClose={() => handlePayInvoiceModal(false)}
        />
      )}
      {state.showReceiveCredit && (
        <ReceiveCredit
          {...(state.invoiceData || {})}
          workType={state.workType}
          handleDownloadDialog={handleDownloadDialog}
          handleClose={() => handleReceiveCreditModal(false)}
          savePurchaseOrder={props.savePurchaseOrder}
          successSnackBar={props.successSnackBar}
          warningSnackBar={props.warningSnackBar}
          getProjectList={props.getProjectList}
          getPoVendors={props.getPoVendors}
          getPOList={props.getPOList}
          getGlobalSetting={props.getGlobalSetting}
          getVendorList={props.getVendorList}
          resetInvoiceData={resetInvoiceData}
        />
      )}
      {state.showFilter && <DateFilter
        startDate={state.startDate}
        endDate={state.endDate}
        invoiceType={state.invoiceType}
        changeFilter={dateChangeFilter}
        workType={state.workType}
        dialogClose={showFilterHandler}
        open={state.showFilter}
        showInvoiceType={true}
      />}

      {projectModule === false ? (
        <p>
          You do not currently have access to any Projects. Please
          contact your Administrator if this is required.
        </p>
      ) : (
        <>
          <div className="purchase-order-block" data-cy="supplier-invoice-list">
            <div className="row">
              <div className="w-auto">
                <h2 className="content-heading text-uppercase" data-cy="heading">Supplier Invoices</h2>
                <div className="col-12 breadcrumb-block p-0">
                  <Breadcrumb>
                    {state.breadCumbText && (
                      <>
                        <Breadcrumb.Item onClick={ViewProjectList} data-cy="projects-breadcrumb">PROJECTS</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={ViewProject} data-cy="project-breadcrumb">{idx(state, _ => _.projectData.name)}</Breadcrumb.Item>
                        <Breadcrumb.Item active data-cy="vendor-invoices-breadcrumb">Vendor Invoices</Breadcrumb.Item>
                      </>
                    )}
                  </Breadcrumb>
                </div>
              </div>
              {!state.projectId && (<div className="w-auto ms-auto mt-auto">
                {writePermission && (
                  <>
                    <button
                      data-cy="supplier-receive-credit"
                      className="receive-invoice-button secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary ms-2"
                      onClick={() => handleReceiveCreditModal(true, true)}
                    >
                      Receive Credit
                    </button>
                    <button
                      data-cy="receive-invoice-button"
                      className="secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary"
                      onClick={() => handlePayInvoiceModal(true, true)}
                    >
                      Receive Invoice
                    </button>
                  </>
                )}
                <Tooltip title="Refresh Data">
                  <button
                    data-cy="refresh-button"
                    onClick={resetInvoiceData}
                    aria-label="filter"
                    className="btn"
                  >
                    <Autorenew />
                  </button>
                </Tooltip>
                <Tooltip title="Filters">
                  <button
                    data-cy="filter-button"
                    onClick={showFilterHandler}
                    aria-label="filter"
                    className="btn"
                  >
                    <FilterAltIcon />
                  </button>
                </Tooltip>
              </div>)}
            </div>

            <div className="row">
              <div className="col-12 mt-3">

                <CustomTable
                  dataCy="supplier-invoice-list-table"
                  columns={state.columns}
                  data={state.suppliersTable}
                  isAction={true}
                  handleMenu={(data) => handleMenu(data)}
                  menu={(data) => (
                    <Popover id="popover-basic" data-cy="invoice-list-table-menu">
                      <Popover.Body>
                        <ul className="action-block-list">
                          {writePermission && !data.isCreditInvoice && <li data-cy="receive-invoice" onClick={() => handlePayInvoiceModal(true)}>
                            Receive Invoice
                          </li>}
                          <li onClick={() => viewPO()} data-cy="view-invoice">
                            View Invoice
                          </li>
                          {data.vendorType === "sub-contractor" && (<li onClick={() => handleDownloadDialog(data.invoiceId)} data-cy="download-payment-schedule">
                            Download Payment Schedule
                          </li>)}
                        </ul>
                      </Popover.Body>
                    </Popover>
                  )}
                  fileName='Supplier Invoices List'
                />

              </div>
            </div>
          </div>
        </>
      )}
    </>
  );

}

const mapStateToProps = (state) => ({
  user: state.user.userData,
  projectModule: state.project.projectModule,
  projectState: state.project,
  projectDetail: state.projectDetail,
});

const mapDispatchToProps = (dispatch) => ({
  getvendorsPOList: bindActionCreators(getvendorsPOList, dispatch),
  getGlobalSettingTemplateTypes: bindActionCreators(getGlobalSettingTemplateTypes, dispatch),
  downloadProjectPO: bindActionCreators(downloadProjectPO, dispatch),
  warningSnackBar: bindActionCreators(warningSnackBar, dispatch),
  getProject: bindActionCreators(getProject, dispatch),
  savePurchaseOrder: bindActionCreators(savePurchaseOrder, dispatch),
  successSnackBar: bindActionCreators(successSnackBar, dispatch),
  getProjectList: bindActionCreators(getProjectList, dispatch),
  getPoVendors: bindActionCreators(getPoVendors, dispatch),
  getPOList: bindActionCreators(getPOList, dispatch),
  getGlobalSetting: bindActionCreators(getGlobalSetting, dispatch),
  getVendorList: bindActionCreators(getVendorList, dispatch),
  getPOInvoices: bindActionCreators(getPOInvoices, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierInvoiceList));
